import { isValidArrayLength } from '@nykaa/utils/validations';
import { FreeGiftOffer, TransformedFreeGiftProduct } from './types';

export const transformFreeGiftOffers = (
  freeGiftOffers: FreeGiftOffer[]
): TransformedFreeGiftProduct[] => {
  if (!isValidArrayLength(freeGiftOffers)) {
    return [];
  }

  const transformedProducts: TransformedFreeGiftProduct[] = [];

  freeGiftOffers.forEach((offer) => {
    const {
      offerId,
      title,
      description,
      deltaAmount,
      deltaTextModified,
      status,
      expiryEpoch,
      freeGiftInfoList,
      offerTnc,
      deltaQuantity,
      offerDiscount,
      offerType,
      offerLabel,
      startEpoch,
      isViewProducts,
    } = offer || {};

    // Check if freeGiftInfoList exists and is an array
    if (!isValidArrayLength(freeGiftInfoList)) {
      return;
    }

    // Iterate through each gift in the freeGiftInfoList
    freeGiftInfoList.forEach((gift) => {
      const {
        productId,
        title: giftTitle,
        sku,
        brandNames,
        productTitle,
        media,
      } = gift || {};

      // Get the first media item or use defaults
      const firstMedia = media && media.length > 0 ? media[0] : null;

      transformedProducts.push({
        offerId,
        offerTitle: title,
        offerDescription: description,
        deltaAmount,
        deltaTextModified,
        status,
        expiryEpoch,
        productId,
        productTitle: productTitle,
        giftTitle,
        sku,
        offerDiscount,
        offerType,
        offerLabel,
        startEpoch,
        offerTnc: offerTnc || '',
        deltaQuantity,
        brandName: isValidArrayLength(brandNames) ? brandNames[0] : '',
        imageUrl: firstMedia?.url || '',
        imageType: firstMedia?.type || 'image',
        isViewProducts,
      });
    });
  });

  return transformedProducts;
};

export default transformFreeGiftOffers;
